import { ClientModel } from "../clientModel.js";
class AbstractPost extends ClientModel {
    transformDataForPersist() {
        const data = {
            ...super.transformDataForPersist()
        };
        data.title = typeof data.title?.raw === "string" ? data.title.raw : data.title?.rendered;
        data.content = typeof data.content?.raw === "string" ? data.content.raw : data.content?.rendered;
        delete data._links;
        delete data.link;
        return data;
    }
    transformDataForPatch() {
        return this.transformDataForPersist();
    }
}
export { AbstractPost };
